import { Brand } from '@Praia-Health/spi-common-utils/types';

/**
 * Determines if the SDK version is new enough to support the Identity Verification page.
 * @param version The current SDK version
 * @param requiredVersion The minimum required SDK version
 * @returns true if the SDK version is valid, false otherwise
 */
export const isSdkVersionValid = (version: string | undefined, requiredVersion: string | undefined): boolean => {
    if (!version || !requiredVersion) {
        return false;
    }

    const [major, minor, patch] = version.split('.').map(Number);
    const [requiredMajor, requiredMinor, requiredPatch] = requiredVersion.split('.').map(Number);

    if (isNaN(major) || isNaN(patch) || isNaN(minor)) {
        return false;
    }

    if (major > requiredMajor) {
        return true;
    }

    if (major === requiredMajor && minor > requiredMinor) {
        return true;
    }

    if (major === requiredMajor && minor === requiredMinor && patch >= requiredPatch) {
        return true;
    }

    return false;
};

/**
 * Should Clear verification be shown on the Register page?
 * Currently, determination is by brand and the client-application using PIP.
 *
 * @param clientId The Azure AD Client ID for the application
 * @param brand Brand-specific feature configuration
 * @returns true if the Identity Verification page should be shown, false otherwise
 */
export function shouldShowIdentityVerificationPage(clientId: string | undefined, brand: Brand): boolean {
    /**
     * For the moment, only specific clients can be shown Clear.
     */
    if (!clientId) {
        return false;
    }

    const isEnabled = brand.identityVerification.clear?.enabled ?? false;
    const isAllowedForAudience = brand.identityVerification.clear?.jwtAudienceList?.includes(clientId) ?? false;
    return isEnabled && isAllowedForAudience;
}
